module.exports = __webpack_public_path__ + "static/8-c1b23f92cd710f579afd81c99c3c2868.jpg";